<template>
    <div class="details_container">
        <TimeSelector @getSelectedDateData="setDate" @reset-feild="closeSelector" />
        <SelectPopOver ref="selectorRef" @setActiveType="setActiveType" />
    </div>
    <div class="cards_row">
        <van-row class="cards_row_content" justify="space-between">
            <van-col span="8">
                <div class="card1">
                    <div>R$ <span>{{ formatCurrency(rewardData.summary.commission) }}</span></div>
                    <div style="padding: 5px;">{{ $t('agent.commission') }}</div>
                </div>
            </van-col>
            <van-col span="7">
                <div class="card2">
                    <div><span>{{ rewardData.summary.commissionRate }}%</span></div>
                    <div style="padding: 5px;">{{ $t('agent.commissionRate') }}</div>
                </div>
            </van-col>
            <van-col span="8">
                <div class="card3">
                    <div>R$ <span>{{ formatCurrency(rewardData.summary.total) }}</span></div>
                    <div style="padding: 5px;">{{ $t('agent.totalCommission') }}</div>
                </div>
            </van-col>
        </van-row>
    </div>
    <div class="claim_Container">
        <div class="claim_card">
            <div style="font-size: 15px; font-weight: 600;">{{ $t('agent.availableCommission') }}</div>
            <van-row style="padding-top: 15px;">
                <van-col span="18" class="commissionValue">
                    <div class="valueText">{{ $t('withdraw.value') }}</div>
                    <div class="amountText">{{ formatCurrency(availabaleCommissionAmount) }}</div>
                </van-col>
                <van-col span="6" style="padding-left: 2%; display: flex;
                align-items: center;">
                    <div :class="availabaleCommissionAmount > 0 ? 'enableBtn' : 'disableBtn'"
                        @click="callCommissionBalanceClaimed">{{ $t('activity.reciev')
                        }}</div>
                </van-col>
            </van-row>
            <div class="recievedAmount">{{ $t('agent.earningRecieved') }} <span>{{
                formatCurrency(recievedCommissionAmount) }}</span></div>
        </div>
    </div>

    <div class="tabel_content">
        <div v-if="activeType == 1">
            <van-row class="tabel_hed">
                <van-col span="9" class="head_alignemnet">{{ $t('agent.directPlayer') }}</van-col>
                <van-col span="6" class="head_alignemnet">{{ $t('agent.rollover') }}</van-col>
                <van-col span="9" class="head_alignemnet">{{ $t('agent.commission') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in detailsList" :key="index">
                <van-col span="9" class="head_alignemnet">{{ item.fromUid }}</van-col>
                <van-col span="6" class="head_alignemnet">{{ item.turnover }}</van-col>
                <van-col span="9" class="head_alignemnet" style="color: #FBA531;">{{ item.coin }}</van-col>
            </van-row>
        </div>
        <div v-if="activeType == 2">
            <van-row class="tabel_hed">
                <van-col span="9" class="head_alignemnet">{{ $t('agent.directPlayer') }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ $t('agent.rollover') }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ $t('common.level') }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ $t('agent.commission') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in detailsList" :key="index">
                <van-col span="9" class="head_alignemnet">{{ item.fromUid }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ item.turnover }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ item.level }}</van-col>
                <van-col span="5" class="head_alignemnet" style="color: #FBA531;">{{ item.coin }}</van-col>
            </van-row>
        </div>


        <NoDataCustom v-if="detailsList.length <= 0" />
        <van-row v-if="total >= pageNumber">
            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                    @click="getNextPageRewardData"></van-col>
        </van-row>
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import SelectPopOver from './selectPopOver.vue';
import TimeSelector from './timeSelector.vue';
import { getRewardDetail } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getRewardDetailDataFunc, RewardDetails, DetailsItem, getNextPageDetailsViewDataFunc, callCommissionBalanceClaim, getCommissionBalanceData } from '@/view/agent/supportScript';
import { useUserStore } from '@/stores/user';
import NoDataCustom from '../../components/common/noDataCustom.vue';

const userStore = useUserStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const detailsList = ref<DetailsItem[]>([])
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const activeType = ref(1)
const selectorRef = ref()
const availabaleCommissionAmount = ref(0)
const recievedCommissionAmount = ref(0)
const uid = ref(userStore.id)
const formatYMD = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const today = new Date();
const date = ref(formatYMD(today));

const rewardData = ref<RewardDetails>({
    summary: {
        commission: 0,
        commissionRate: 0,
        total: 0,
    },
    details: [],
    totalPage: 0
})
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const setDate = (value: any) => {
    date.value = value
    detailsList.value = []
    pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()
}
const setActiveType = (type: any) => {
    detailsList.value = []
    activeType.value = type
     pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()

}
const getNextPageRewardData = () => {
    getNextPageDetailsViewDataFunc(total, pageNumber, getRewardData, loadingRef)
}
const getCommissionBalance = async () => {
    const { data } = await getCommissionBalanceData(uid, loadingRef,)
    availabaleCommissionAmount.value = data?.totalCommission || 0
    recievedCommissionAmount.value = data?.claimedCommission || 0
}

const callCommissionBalanceClaimed = async () => {
    if (availabaleCommissionAmount.value > 0) {
        await callCommissionBalanceClaim(uid, loadingRef, getCommissionBalance, showSuccess, showError)
        pageNumber.value = 1
        total.value = 0
        rewardData.value = {
            summary: {
                commission: 0,
                commissionRate: 0,
                total: 0,
            },
            details: [],
            totalPage: 0
        }
        detailsList.value = []
        getRewardDetailDataFunc(
            getRewardDetail,
            date,
            pageNumber,
            activeType,
            rewardData,
            detailsList,
            total,
            loadingRef,
            showError
        )
    }

}
const getRewardData = () => {
    getRewardDetailDataFunc(
        getRewardDetail,
        date,
        pageNumber,
        activeType,
        rewardData,
        detailsList,
        total,
        loadingRef,
        showError
    )
}
const closeSelector = () => {
    selectorRef.value.close()
}
onMounted(() => {
    loadingRef.value.open()
    getRewardData()
    getCommissionBalance()
})
</script>

<style scoped>
.details_container {
    padding: 10px 15px;
}

.cards_row {
    padding: 10px 25px;
}


.cards_row_content {
    font-size: 13px;
    color: #ffffff82;
    height: max-content;
}

.card {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.45);
    font-size: 13px;
    font-weight: bold;
}

.card1 {
    background: #1b417385;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card1 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card2 {
    background: #1b417385;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card2 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card3 {
    background-image: linear-gradient(166deg, #034178 0%, #061a31 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card3 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card span {
    color: #fff;
    font-size: 24px;
    padding: 0 5px;
}

.claim_Container {
    padding: 13px 15px;
}

.claim_card {
    background: #101629;
    color: #9BA7BE;
    font-size: 14px;
    border-radius: 5px;
    padding: 10px;
}

.commissionValue {
    border-radius: 10px;
    border: 1px solid #15408499;
    padding: 10px;
    display: flex;
    align-items: center;
}

.valueText {
    color: #9BA7BE;
    font-size: 13px;
    padding: 0 20px;
}

.amountText {
    color: #FBA531;
    font-size: 20px;
    font-weight: bold;
}

.disableBtn {
    padding: 5%;
    color: #aca7aea0;
    background-color: #42557342;
    font-size: 14px;
    border-radius: 10px;
    height: 75%;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

}

.enableBtn {
    padding: 5%;
    color: #ffffff;
    font-weight: 600;
    background-color: #19468c;
    font-size: 14px;
    border-radius: 10px;
    height: 75%;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.recievedAmount {
    padding-top: 10px;
    color: #9BA7BE;
    font-size: 15px;
}

.recievedAmount span {
    font-size: 12px;
    color: #fff;
}

.tabel_content {
    overflow: hidden;
    margin: 10px 15px 15px;
}

.tabel_hed {
    background: #151C30;
    color: rgba(255, 255, 255, 0.85);
    padding: 15px 10px;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.tabel_row {
    color: #fff;
    padding: 15px 10px;
    font-size: 13px;
    background: #0a1c33;
}

.tabel_row:nth-child(even) {
    background: #131821;
}

.arrowDown {
    display: flex;
    justify-content: center;
    padding: 15px;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
}
</style>